import React, { useState } from "react";
import "./viewCode.scss";
import "./preCode.scss";

function ViewCode({preContent, fixedHeight}: any) {
    const [open, setopen] = useState(false);
    return(
        <>
            <div className="viewCode_container">
                <div className={`viewCodebtn`}onClick={()=>setopen(!open)}><div className={open ? "viewCodebr" : ""}>VIEW CODE</div></div>
            </div>
            {open && <div className={`${fixedHeight && "srcCodeFixedHeight"} src_code`}>
                <code>
                    {preContent}
                </code>
            </div>}
        </>
    )
}

export default ViewCode;